/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, number, func, string,
} from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import configENV from '../../../config';

const { PERSIST_KEY } = configENV;

const styles = (theme) => ({
    paginationWrapper: {
        width: '100%',
        maxWidth: 900,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        margin: '10px 0 20px',
        '& .pagination': {
            '& > span': {
                display: 'inline-block',
                width: 24,
                marginRight: 8,
                padding: '2px 6px',
                cursor: 'pointer',
                fontWeight: 700,
                textAlign: 'center',
                '&:first-child': {
                    margin: '0 8px',
                },
                '&:not(.currentPage):hover': {
                    color: theme.palette.common.white,
                    border: '1px solid #161616', // TODO
                    'background-color': '#161616', // TODO
                },
                '&.currentPage': {
                    color: theme.palette.primaryButton,
                    cursor: 'default',
                    // textDecoration: 'underline',
                },
            },
        },
        '& .navButton': {
            display: 'inline-block',
            borderRadius: '50%',
            boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.5)',
            cursor: 'pointer',
            width: 28,
            height: 28,
            position: 'relative',
            '&.disabled': {
                opacity: 0.4,
                cursor: 'default',
            },
            '&.previous': {
            },
            '&.next': {
            },
        },
    },
});

const DesktopPagination = (props) => {
    const {
        classes, currentPage, totalPage, occasionId,
        orderId, handleGiftListPaginationChanged,
    } = props;
    const prevPage = currentPage - 1;
    const nextPage = currentPage + 1;
    const prevPageEnabled = currentPage > 1;
    const nextPageEnabled = currentPage < totalPage;

    if (totalPage === 1) return null;

    const pageArray = [];
    while (pageArray.length < totalPage) {
        pageArray.push(pageArray.length + 1);
    }

    const handleBackToTopClicked = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    return (
        <>
            <div className={classes.paginationWrapper}>
                <div
                    role="presentation"
                    className={`navButton previous ${!prevPageEnabled ? 'disabled' : ''}`}
                    onClick={(event) => {
                        if (!prevPageEnabled) return false;
                        handleBackToTopClicked();
                        return handleGiftListPaginationChanged(event, occasionId, prevPage, orderId);
                    }}
                >
                    <ChevronLeft />
                </div>
                <div className="pagination">
                    {
                        pageArray.map((p) => {
                            const isCurrentPage = p === currentPage;
                            const currentPageClass = isCurrentPage ? 'currentPage' : '';
                            return (
                                <span
                                    role="presentation"
                                    className={currentPageClass}
                                    onClick={(event) => {
                                        if (!isCurrentPage) {
                                            handleBackToTopClicked();
                                            return handleGiftListPaginationChanged(event, occasionId, p, orderId);
                                        }
                                        return false;
                                    }}
                                >
                                    {p}
                                </span>
                            );
                        })
                    }
                </div>
                <div
                    role="presentation"
                    className={`navButton next ${!nextPageEnabled ? 'disabled' : ''}`}
                    onClick={(event) => {
                        if (!nextPageEnabled) return false;
                        handleBackToTopClicked();
                        return handleGiftListPaginationChanged(event, occasionId, nextPage, orderId);
                    }}
                >
                    <ChevronRight />
                </div>
            </div>
        </>
    );
};

DesktopPagination.propTypes = {
    classes: object.isRequired,
    occasionId: string.isRequired,
    currentPage: number.isRequired,
    totalPage: number.isRequired,
    handleGiftListPaginationChanged: func.isRequired,
    orderId: string.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        currentPage: newState.giftList.currentPage, // use this to update the component
        totalPage: newState.giftList.totalPage,
        orderId: newState.giftList.orderId,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleGiftListPaginationChanged: (event, occasionId, newPage, orderId) => dispatch(EventDispatcher.handleGiftListPaginationChanged(event, occasionId, newPage, orderId)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(DesktopPagination));
